import { useState, useEffect } from 'react';

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Marketing Manager",
    initials: "SM",
    quote: "Practiced my salary negotiation for a week and got a £8,500 raise! The AI opponent felt so real, I was actually nervous.",
    stars: 5
  },
  {
    name: "James Chen",
    role: "Freelance Designer",
    initials: "JC",
    quote: "Doubled my freelance rates after using the script generator. Clients respect confidence, and this app gave me that.",
    stars: 5
  },
  {
    name: "Emma Patel",
    role: "Small Business Owner",
    initials: "EP",
    quote: "Saved £420/year on business insurance with one call. The coaching tips are gold. Worth every penny.",
    stars: 5
  },
  {
    name: "Michael Rodriguez",
    role: "Software Engineer",
    initials: "MR",
    quote: "Negotiated a signing bonus I didn't think was possible. The roleplay scenarios prepared me for every objection.",
    stars: 5
  },
  {
    name: "Olivia Thompson",
    role: "HR Professional",
    initials: "OT",
    quote: "Got my car price down by £2,200 using the tactics from this app. The script generator is a game-changer.",
    stars: 5
  },
  {
    name: "David Kim",
    role: "Startup Founder",
    initials: "DK",
    quote: "Negotiated better terms with investors after practicing. The AI feedback is more valuable than any course.",
    stars: 5
  },
  {
    name: "Rachel Green",
    role: "Teacher",
    initials: "RG",
    quote: "Reduced my rent by £150/month! Never thought I could negotiate that, but the app gave me the confidence.",
    stars: 5
  },
  {
    name: "Tom Wilson",
    role: "Sales Director",
    initials: "TW",
    quote: "My team uses this for client negotiations. It's like having a coach in your pocket. Worth 10x the price.",
    stars: 5
  },
  {
    name: "Sophia Anderson",
    role: "Consultant",
    initials: "SA",
    quote: "Landed a consulting contract at 40% higher rate. The win probability feature helped me aim higher with confidence.",
    stars: 5
  }
];

function TestimonialsSection() {
  const [displayedTestimonials, setDisplayedTestimonials] = useState([]);

  useEffect(() => {
    // Shuffle and pick 3 random testimonials on each load
    const shuffled = [...testimonials].sort(() => 0.5 - Math.random());
    setDisplayedTestimonials(shuffled.slice(0, 3));
  }, []);

  return (
    <section className="py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-['Outfit'] text-4xl font-bold text-center mb-12">
          What Our <span className="text-green-500">Ninjas</span> Say
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {displayedTestimonials.map((testimonial, idx) => (
            <div key={idx} className="ninja-card">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center text-xl font-bold">
                  {testimonial.initials}
                </div>
                <div>
                  <div className="font-bold">{testimonial.name}</div>
                  <div className="text-sm text-gray-400">{testimonial.role}</div>
                </div>
              </div>
              <div className="text-yellow-500 mb-3">
                {'★'.repeat(testimonial.stars)}
              </div>
              <p className="text-gray-300 italic">&quot;{testimonial.quote}&quot;</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <p className="text-gray-400">Join 1,000+ negotiators who've saved over £250,000 combined</p>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
